import gql from 'graphql-tag';
const CURRENT_USER = gql`
  query currentUser {
    currentUser @client {
      id
      username
      email
      cognitoUserId
      isAuthenticated
      avatar
      features
      notifications
      defaultRole
      role
      roles
      isAdmin
      isPreviewOrg
      permission
      ssoToken
      campaignTableDisplayColumns
      timezone
    }
  }
`;

export default CURRENT_USER;
